import { render } from "./WithIconAndDescription.vue?vue&type=template&id=a4cbd15e"
import script from "./WithIconAndDescription.vue?vue&type=script&lang=ts"
export * from "./WithIconAndDescription.vue?vue&type=script&lang=ts"
script.render = render

export default script